import FilterLayout from "../../layout/filter/FilterLayout";
import {useGetFullnodeList} from "../../../core/services/react-query/fullnode";
import {useMemo, useState} from "react";
import {CacheKeys, fullnodeFilterOptions, fullnodeSortOptions} from "../../../core/constants/filter";
import {useWindowSize} from "../../../core/hooks/common/useWindowSize";
import {TABLET_SIZE} from "../../../core/constants/common";
import FullnodeListTable from "./FullnodeListTable";
import RFullnodeListTable from "../../responsive/main/fullnode/RFullnodeListTable";
import {useSearchParams} from "react-router-dom";


const FullnodeList = () => {

    const [searchParams] = useSearchParams()

    const { width } = useWindowSize()
    const [data, setData] = useState({loading: true, data: null})
    const onQuerySuccess = (res) => setData(res)
    const Comp = width > TABLET_SIZE ? FullnodeListTable : RFullnodeListTable

    const extra = {}
    try {
        const symbol = searchParams.get('symbol')
        if (symbol) extra.symbol = symbol
        const status = searchParams.get('status')
        if (status) extra['cumulative.status'] = status
    }catch (_) {}

    return (
        <FilterLayout
            query={useGetFullnodeList}
            cache={CacheKeys.FULLNODE}
            options={fullnodeFilterOptions}
            onQuerySuccess={onQuerySuccess}
            sortOptions={fullnodeSortOptions}
            extra={extra}
        >
            <Comp data={data} />
        </FilterLayout>
    )
}

export default FullnodeList
